<template>
    <span v-if="hasImage" class="avatar mr-1" v-bind:style="{'background-image': url}" data-avatar-type="image"></span>
    <span v-else class="avatar" data-avatar-type="initials">{{user | initials}}</span>
</template>

<script lang="ts">
  import Vue from "vue";
  import ImageUpload from "../../formability/organization_settings/models/imageUpload";
  import initialable from "../mixins/initialable";

  export default Vue.extend({
    props: {
      user: {
        type: Object as () => {
          image_uploads: ImageUpload[],
        },
        default: () => ({})
      },
      currentUserId: {
        type: String
      },
      imageName: {
        type: String,
        default: 'avatar'
      }
    },
    mixins: [initialable],
    data: function() {
      return {
      }
    },
    computed: {
      userId(): string {
        if (this.user.creator_id !== undefined) {
          return this.user.creator_id
        }
        return this.user.id
      },
      isCurrentUser(): boolean {
        return this.userId === this.currentUserId;
      },
      imageUpload(): ImageUpload {
        return this.user.avatar || (this.user.image_uploads && this.user.image_uploads.find(img => img.name === this.imageName));
      },
      hasImage(): boolean {
        return this.isCurrentUser && !!this.imageUpload;
      },
      url(): string {
        switch (this.imageName) {
          case 'avatar':
            return this.avatarUrl;
          case 'logo':
            return this.logoUrl;
        }
      },
      avatarUrl() {
        return `url(/account/image_uploads/${this.imageUpload.id}?userId=${this.user.id})`
      },
      logoUrl() {
        return `url(/organization/settings/image_uploads/${this.imageUpload.id}?organization_id=${this.user.id})`;
      }
    },
    methods: {}
  });

</script>
